import fetch from './http';
import api from './interface';

// 商户登录
export function platformIndex (data) {
    return fetch({
        url: api.PLATFORM_INDEX,
        method: 'POST',
        data
    });
}

export function queryProductRelationByPid (data) {
    return fetch({
        url: api.QUERY_PRODUCT_RELATION_BY_PID,
        method: 'POST',
        data
    });
}

export function queryProductRelationByCid (data) {
    return fetch({
        url: api.QUERY_PRODUCT_RELATION_BY_CID,
        method: 'POST',
        data
    });
}

export function huafeiRecharge (data) {
    return fetch({
        url: api.PLATFORM_HUAFEI_SEND,
        method: 'POST',
        data
    });
}

export function videoRecharge (data) {
    return fetch({
        url: api.PLATFORM_VIDEO_SEND,
        method: 'POST',
        data
    });
}

export function jiayoukaRecharge (data) {
    return fetch({
        url: api.PLATFORM_JIAYOUKA_SEND,
        method: 'POST',
        data
    });
}

export function orderQueryList (data) {
    return fetch({
        url: api.ORDER_QUERY_LIST,
        method: 'POST',
        data
    });
}

export function gameRecharge(data){
    return fetch({
        url: api.PLATFORM_GAME_SEND,
        method: 'POST',
        data
    });
}

export function elecCardRecharge(data){
    return fetch({
        url: api.PLATFORM_ELEC_CARD_SEND,
        method: 'POST',
        data
    });
}


export function indexBannersQuery(data){
    return fetch({
        url: api.INDEX_BANNER_QUERY,
        method: 'POST',
        data
    });
}




export function equityCardInfoQuery(data){
    return fetch({
        url: api.EQUITY_CARD_INFO_QUERY,
        method: 'POST',
        data
    });
}

export function equityCardQuery(data){
    return fetch({
        url: api.EQUITY_CARD_QUERY,
        method: 'POST',
        data
    });
}

export function equityCardEquity(data){
    return fetch({
        url: api.EQUITY_CARD_INFO_QUERY,
        method: 'POST',
        data
    });
}

export function exchangeEquity(data){
    return fetch({
        url: api.EQUITY_CARD_EXCHANGE,
        method: 'POST',
        data
    });
}

export function queryMakingOrder(data){
    return fetch({
        url: api.ORDER_QUERY_ONE,
        method: 'POST',
        data
    });
}


export function equityCodeQuery(data){
    return fetch({
        url: api.EQUITY_CODE_QUERY,
        method: 'POST',
        data
    });
}


export function sendValidCode(data){
    return fetch({
        url: api.SEND_VALID,
        method: 'POST',
        data
    });
}

export function equityCodeExchange(data){
    return fetch({
        url: api.EQUITY_CODE_EXCHANGE,
        method: 'POST',
        data
    });
}


export function jiuGongGeInit(data){
    return fetch({
        url: api.JIUGONGGE_INIT,
        method: 'POST',
        data
    });
}

export function jiuGongGeQueryPrizeList(data){
    return fetch({
        url: api.JIUGONGGE_QUERY_MYPRIZELIST,
        method: 'POST',
        data
    });
}
export function jiuGongGeDraw(data){
    return fetch({
        url: api.JIUGONGGE_DRAW,
        method: 'POST',
        data
    });
}

export function luckWheelQueryList(data){
    return fetch({
        url: api.LUCK_WHEEL_QUERY_PRODUCT_LIST,
        method: 'POST',
        data
    });
}

export function luckWheel(data){
    return fetch({
        url: api.LUCK_WHEEL,
        method: 'POST',
        data
    });
}

export function customer_login(data){
    return fetch({
        url: api.CUSTOMER_LOGIN,
        method: 'POST',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/index.js